class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
		// 20.O2: native theme only regenerates on add-to-cart + drawer open, so
		// qty changes and removals left stale suggestions (and stale in-cart
		// exclusions). CartForm dispatches 'cart-updated' on #AjaxCartForm after
		// every qty/remove; that element survives cart refreshes (only its
		// innerHTML is replaced), so this listener persists.
		const cartForm = document.getElementById('AjaxCartForm');
		if ( cartForm ) {
			cartForm.addEventListener('cart-updated', () => {
				this.generateRecommendations();
			});
		}
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
          if ( innerHTML ) {
          	// 20.O2: when the in-cart filter leaves nothing to suggest, clear
          	// instead of keeping the previous (now stale) cards.
          	if ( innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
          		this.innerHTML = innerHTML.innerHTML;
          	} else {
          		this.innerHTML = '';
          	}
          }
				})
				.catch(e=>{
					console.warn(e);
				})
		}
	}
}
customElements.define('cart-recommendations', CartRecommendations);